import { createAction } from 'typesafe-actions';
import { TransactionArchiveResponse } from 'types/dto';
import { TransactionArchiveResult } from 'types/store';

export enum SystemTransactionHandleAction {
  ArchiveRequest = 'SYSTEM_TRANSACTION_ARCHIVE_REQUEST',
  ArchiveResponse = 'SYSTEM_TRANSACTION_ARCHIVE_RESPONSE',
  ArchiveResult = 'SYSTEM_TRANSACTION_ARCHIVE_RESULT',
  Error = 'SYSTEM_TRANSACTION_HANDLE_ERROR',
  RestoreRequest = 'SYSTEM_TRANSACTION_RESTORE_REQUEST',
  RestoreResponse = 'SYSTEM_TRANSACTION_RESTORE_RESPONSE',
}

export const systemTransactionArchiveRequest = createAction(
  SystemTransactionHandleAction.ArchiveRequest,
)<Array<string>>();
export const systemTransactionArchiveResponse = createAction(
  SystemTransactionHandleAction.ArchiveResponse,
)<TransactionArchiveResponse>();
export const systemTransactionArchiveResult = createAction(
  SystemTransactionHandleAction.ArchiveResult,
)<TransactionArchiveResult>();

export const systemTransactionHandleError = createAction(
  SystemTransactionHandleAction.Error,
)<Error>();

export const systemTransactionRestoreRequest = createAction(
  SystemTransactionHandleAction.RestoreRequest,
)<Array<string>>();
export const systemTransactionRestoreResponse = createAction(
  SystemTransactionHandleAction.RestoreResponse,
)<Array<string>>();
